import reducers from './reducers.js';
import fetch from '../../fetch.js';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared';
import environment from '../../../environment';

const brownfield = (() => {
    const getBrownfield = (id) => {
        return fetch({
            type: 'GET',
            url: `${environment.get('API_HOST')}/brownfield/${id}`,
            async: false
        }).then(reducers.brownfield, notifyError);
    };

    return {
        getBrownfield
    };
})();

export default brownfield;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/brownfield/index.js